/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_UitlegInputs */

const nl_planning_vakanties_uitleg = /** @type {(inputs: Planning_Vakanties_UitlegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op deze dagen is er geen gym. Ze gelden voor de hele school en staan ook in de jaarplanning en in Mijn lesweek.`)
};

/**

* @param {Planning_Vakanties_UitlegInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_uitleg = /** @type {((inputs?: Planning_Vakanties_UitlegInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_UitlegInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_uitleg(inputs)
});
export { planning_vakanties_uitleg as "planning.vakanties.uitleg" }